import React from 'react'
import styled from 'styled-components'
import { ILocalFavourite } from 'types/location'
import { breakpointUpTo } from 'utils/breakpoints'
import { GatsbyImage } from 'gatsby-plugin-image'

const Wrapper = styled.a`
  background-color: ${({ theme }) => theme.colors.white};
  border: 4px solid rgba(26, 26, 26, 0.06);
  padding: ${({ theme }) => theme.space[4]};
  cursor: pointer;
  transition: 0.2s border;
  display: flex;
  flex-direction: column;
  place-items: center;
  width: 270px;
  &:hover,
  &:active {
    border: 4px solid #1a1a1a;
  }
`
const StyledParagraph = styled.p`
  margin: ${({ theme }) => theme.space[2]} 0 0 0;
  ${({ theme }) => theme.typography.LrgBody3};

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    ${({ theme }) => theme.typography.MedBody3};
  }
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    ${({ theme }) => theme.typography.SmBody3};
  }
`
export type LocalFavouriteItemProps = Omit<ILocalFavourite, 'id'>
export const LocalFavouriteItem = ({
  image,
  description,
  url,
}: LocalFavouriteItemProps) => (
  <Wrapper href={url}>
    <GatsbyImage
      image={image.image.gatsbyImageData}
      alt={image.alternativeText}
    />
    <StyledParagraph>{description}</StyledParagraph>
  </Wrapper>
)
